import {Suspense} from 'react';
import type {RouteObject} from 'react-router';
import {createBrowserRouter} from 'react-router-dom';

import {
  AchievementPage,
  ChallengeDetailPage,
  ChallengesPage,
  DepositPage,
  DepositPayPalPage,
  FriendsPage,
  HomePage,
  LeaderboardPage,
  LiveChallengePage,
  LoginPage,
  MakeMatchPage,
  MatchLoadingPage,
  OtpPage,
  ProfilePage,
  ReferralPage,
  StorePage,
  UserDetailsPage,
  WalletPage,
  WithdrawPage,
} from './lazy-pages';
import {PrivateOutlet} from './PrivateOutlet';

import {WithBottomLNavbarLayout} from '@/components/organisms/layouts/WithBottomNavbarLayout/WithBottomNavbarLayout';
import {AchievementsTemplate} from '@/components/templates/Achievement';
import {ChallengesPageTemplate} from '@/components/templates/ChallengesPageTemplate';
import ChallengeDetailPageTemplate from '@/components/templates/ChallengesPageTemplate/ChallengeDetailPageTemplate';
import {HomePageTemplate} from '@/components/templates/HomePageTemplate';
import {LeaderBoardTemplate} from '@/components/templates/LeaderBoard/LeaderBoardTemplate';
import MatchLoadingTemplate from '@/components/templates/MatchLoading/MatchLoadingTemplate';
import ProfileSkeleton from '@/components/templates/Profile/ProfileSkeleton';
import {StoreTemplate} from '@/components/templates/Store';
import {UserDetailsSkeleton} from '@/components/templates/UserDetails';

const routeObjects: RouteObject[] = [
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/otp',
    element: <OtpPage />,
  },
  {
    path: '/',
    element: <PrivateOutlet />,
    children: [
      {
        path: '/',
        element: <WithBottomLNavbarLayout />,
        children: [
          {
            path: '/',
            element: (
              <Suspense fallback={<HomePageTemplate />}>
                <HomePage />
              </Suspense>
            ),
          },
          {
            path: '/challenges',
            element: (
              <Suspense fallback={<ChallengesPageTemplate />}>
                <ChallengesPage />
              </Suspense>
            ),
          },
          {
            path: '/wallet',
            element: <WalletPage />,
          },
          {
            path: '/leader-board',
            element: (
              <Suspense fallback={<LeaderBoardTemplate />}>
                <LeaderboardPage />
              </Suspense>
            ),
          },
          {
            path: '/store',
            element: (
              <Suspense fallback={<StoreTemplate />}>
                <StorePage />
              </Suspense>
            ),
          },
          {
            path: '/achievements',
            element: (
              <Suspense fallback={<AchievementsTemplate />}>
                <AchievementPage />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: '/referrals',
        element: <ReferralPage />,
      },
      {
        path: '/friends',
        element: <FriendsPage />,
      },
      {
        path: '/challenge-detail/:id',
        element: (
          <Suspense fallback={<ChallengeDetailPageTemplate />}>
            <ChallengeDetailPage />
          </Suspense>
        ),
      },
      {
        path: '/user-details',
        element: (
          <Suspense fallback={<UserDetailsSkeleton />}>
            <UserDetailsPage />
          </Suspense>
        ),
      },
      {
        path: '/live-challenge/:id',
        element: <LiveChallengePage />,
      },
      {
        path: '/withdraw/:walletId',
        element: <WithdrawPage />,
      },
      {
        path: '/deposit',
        element: <DepositPage />,
      },
      {
        path: '/deposit-paypal',
        element: <DepositPayPalPage />,
      },
      {
        path: '/makematch',
        element: <MakeMatchPage />,
      },
      {
        path: '/matchloading',
        element: (
          <Suspense fallback={<MatchLoadingTemplate />}>
            <MatchLoadingPage />
          </Suspense>
        ),
      },
      {
        path: '/profile',
        element: (
          <Suspense fallback={<ProfileSkeleton />}>
            <ProfilePage />
          </Suspense>
        ),
      },
    ],
  },
];

export const router = createBrowserRouter(routeObjects);
